import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Modal, Row, Card, Dropdown } from 'react-bootstrap'
import { Book, Eye } from 'react-bootstrap-icons'
import toast from 'react-hot-toast'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import Cookies from 'js-cookie'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { FaArrowLeft, FaEdit, FaRemoveFormat, FaTrash } from 'react-icons/fa'
import { BsThreeDotsVertical, BsPencilFill, BsTrashFill } from 'react-icons/bs'
import axios from 'axios'
import DeleteEnrolledCourse from './DeleteEnrolledCourse'
import { Table,Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import TablePagination from './commonComponents/TablePagination'
import { useInstitute } from './commonComponents/InstituteContext'
import { LuGraduationCap } from 'react-icons/lu'

const getApiErrorMessage = (error, fallback = 'Something went wrong.') => {
  const data = error.response?.data
  const fieldErrors = data?.errors
  if (fieldErrors && typeof fieldErrors === 'object') {
    const messages = Object.values(fieldErrors).flat().filter(Boolean)
    if (messages.length) return messages.join(' ')
  }
  return data?.message || data?.result || fallback
}

const EnrolledCourses = () => {
  const {token, logout, user:authUser} = useAuth()
  const isAdmin =
    authUser?.user_type === 'admin' || authUser?.roles?.includes('admin')
  const { isCollapsed } = useSidebar()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id: instituteId } = useInstitute();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  const location = useLocation()
  const { id } = useParams()
  console.log('studentId', id)

  const studentName = location.state?.student_name
  const studentAdmissionNumber = location.state?.admission_number
  const student_id = location.state?.student_id || id

  console.log('ENR. STUDENT ID:', student_id)
  const initialData = []
  const [studentCount, setStudentCount] = useState(null)
  const [countColor, setCountColor] = useState('') // Add color for the response

  const [data, setData] = useState(initialData)
  const [newEnroll, setNewEnroll] = useState({
    student_id: student_id,
    course_id: '',
    class_id: '',
    enroll_date: '',
    roll_number: '',
  })

  const navigate = useNavigate()
  const [showModal, setShowModal] = useState(false)
  const [user, setUser] = useState(null)
  const [courses, setCourses] = useState([])
  const [classes, setClasses] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectedNewCourse, setSelectedNewCourse] = useState([])
  const [courseTouched, setCourseTouched] = useState(false)
  const [originalClassId, setOriginalClassId] = useState(null)
  const [deleteModal, setDeleteModal] = useState(false)
  const [selectedStudentId, setSelectedStudentId] = useState(null)
  const [selectedCourseId, setSelectedCourseId] = useState(null)
  const [selectedCoursename, setSelectedCoursename] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)

  const [studentDetails, setStudentDetails] = useState({
    name: '',
    admission_number: '',
  })

  console.log('STUDENT DETAILS:', studentDetails)
  const [showEditModal, setShowEditModal] = useState(false)
  const [editFormData, setEditFormData] = useState({
    student_id: '',
    course_id: '',
    class_id: '',
    enroll_date: '',
    roll_number: '',
  })

  useEffect(() => {
    ApiEndpoints.getAllClasses().then((res) => setClasses(res.data.data))
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
  }, [])

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteID', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }

    const fetchFilteredData = async () => {
      console.log('Insti ID: ', institueId)
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'institute-Id': Number(institueId),
        }

        console.log('Request Headers:', headers)

        const response = await axios.get(
          BASE_URL+'/student/all',
          { headers },
        )
        const students = response.data.data
        const matchedStudent = students.find(
          (std) => std.id === Number(student_id),
        )
        if (matchedStudent) {
          setStudentDetails({
            name: matchedStudent.name,
            admission_number: matchedStudent.admission_number,
          })
        } else {
          console.error('Student not found')
        }
      } catch (error) {
        console.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    if (student_id) {
      fetchFilteredData()
    }
  }, [student_id])

  useEffect(() => {
    const fetchEnrolled = async () => {
      try {
        const response = await axios.get(
          BASE_URL+'/get/student/all/enroll',
          {
            params: { student_id },
            headers:{
              Authorization: `Bearer ${token}`
            }
          },
        )
        console.log('RESPONSE: ', response)
        setData(response.data.data)
      } catch (error) {
        console.error(error.response?.data?.resul)
      }
    }
    fetchEnrolled()
  }, [loading])

  const handleEditEnroll = (
    student_id,
    course_id,
    currentClassId,
    enroll_date,
    roll_number,
  ) => {
    let formattedDate = ''
    if (enroll_date) {
      const dateObj = new Date(enroll_date)
      if (!isNaN(dateObj)) {
        formattedDate = dateObj.toISOString().split('T')[0] // "YYYY-MM-DD"
      }
    }
    setOriginalClassId(currentClassId)
    setEditFormData({
      student_id,
      course_id,
      class_id: currentClassId,
      enroll_date: formattedDate,
      roll_number: roll_number || '',
    })
    setShowEditModal(true)
  }

  const handleUpdateClass = async () => {
    try {
      const token = JSON.parse(Cookies.get('user'))?.token
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }

      const classId = Number(editFormData.class_id) || Number(originalClassId)
      if (!Number.isFinite(classId) || classId <= 0) {
        toast.error('Please select a class.')
        return
      }

      const payload = {
        student_id: Number(editFormData.student_id),
        course_id: Number(editFormData.course_id),
        class_id: classId,
        roll_number: editFormData.roll_number,
      }

      if (editFormData.enroll_date) {
        payload.enroll_date = editFormData.enroll_date
      }

      const response = await axios.put(
        BASE_URL+'/student/class/change',
        payload,
        { headers },
      )

      toast.success(response.data.message || 'Class updated successfully')
      setShowEditModal(false)
      setLoading(!loading) // Refresh enrolled data
    } catch (error) {
      toast.error(getApiErrorMessage(error, 'Failed to update class'))
    }
  }

  const handleNavigateToCreateClass = () => {
    navigate('/AddClass')
  }

  const handleBack = () => {
    navigate(`/student/profile/${student_id}`)
  }
  const handleCourseChange = (e) => {
    const courseId = e.target.value
    console.log('Selected course Id:', courseId)
    setCourseTouched(true)
    setSelectedNewCourse(courseId)
    setNewEnroll((prev) => ({ ...prev, course_id: courseId }))
    // setClasses([])
    setStudentCount(null)
    console.log('Cleared Classes')

    if (courseId) {
      ApiEndpoints.getAllClassesByCourseId(courseId)
        .then((res) => {
          const { data } = res
          if (data.status === false || !data.data?.length) {
            toast.error('No classes found for this course.')
            setClasses([])
            setStudentCount(null)
          } else {
            setClasses(data.data)
          }
        })
        .catch((error) => {
          // This is where 404 or other errors come
          if (
            error.response?.data?.message === 'No classes found for this course'
          ) {
            // toast.error('No classes found for this course.')
            setStudentCount(null)
          } else {
            console.error('Error fetching classes:', error)
            toast.error('Something went wrong while fetching classes.')
          }
          setClasses([])
          setStudentCount(null)
        })
    }
  }

  const handleClassChange = (e) => {
    const classId = e.target.value
    setNewEnroll((prev) => ({ ...prev, class_id: classId }))

    setEditFormData((prev) => ({ ...prev, class_id: classId }))

    // Clear previous student count
    setStudentCount(null)
    setCountColor('')

    if (classId) {
      // Call the API to get the student count for the selected class
      
      fetch(
        BASE_URL+`/get/class/student/count?class_id=${classId}`,{
        headers :
          {
          Authorization: `Bearer ${token}`
        }
      } 
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data?.status &&
            data?.data?.current !== undefined &&
            data?.data?.maximum_limit !== undefined
          ) {
            const current = data.data.current === null ? 0 : data.data.current // Treat null as 0
            const maximum_limit = parseInt(data.data.maximum_limit, 10) // Parse maximum_limit as a number
            setStudentCount({ current, maximum_limit }) // Set the state with correct property names
            setCountColor('green') // Example color for success
          } else {
            setStudentCount('No data available')
            setCountColor('red') // Example color for no data
          }
        })
        .catch((error) => {
          console.error('Error fetching student count:', error)
          setStudentCount('Error fetching data')
          setCountColor('red') // Example color for error
        })
    }
  }

  useEffect(() => {
    const userLogged = Cookies.get('user')
    console.log('userLogged', userLogged)
    if (userLogged) {
      try {
        setUser(JSON.parse(userLogged))
        console.log('User:', JSON.parse(userLogged))
      } catch (error) {
        console.error('Error parsing user data:', error)
        Cookies.remove('user')
      }
    }
  }, [])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setNewEnroll((prev) => ({ ...prev, [name]: value }))
  }
  const handleSave = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      const institueId = Cookies.get('institute_id')
      console.log('INSTITUTE ID', institueId)

      const payload = {
        student_id: student_id,
        course_id: parseInt(newEnroll.course_id),
        class_id: parseInt(newEnroll.class_id),
        enroll_date: new Date().toISOString().split('T')[0],
        roll_number: newEnroll.roll_number,
      }
      const response = await axios.post(
        BASE_URL+'/student/course/enroll',
        payload,{
          headers:{
            Authorization: `Bearer ${token}`
          }
       }
      )
      console.log('Sending Response: ', response)

      setNewEnroll(response)
      // setNewCourse({ course_name: '', duration: '', fee: '', description: '' })

      toast.success(response.data.message)
      setShowModal(false)
    } catch (error) {
      toast.error(getApiErrorMessage(error, 'Something went wrong.'))
    } finally {
      setLoading(false)
    }
  }

  const handleViewFees = (student_id, course_id, class_id) => {
    navigate(`/ManageStudentFees/${student_id}/${course_id}/${class_id}`)
    console.log('Student ID:', student_id)
    console.log('Course ID:', course_id)
    console.log('Class ID:', class_id)
  }

  const handleDeleteEnroll = (studentId, courseId, courseName) => {
    setSelectedStudentId(studentId)
    setSelectedCourseId(courseId)
    setSelectedCoursename(courseName)
    setDeleteModal(true)
  }

  const handleConfirmDelete = () => {
    setData((prevData) =>
      prevData.filter(
        (item) =>
          !(
            item.student_id === selectedStudentId &&
            item.course_id === selectedCourseId
          ),
      ),
    )
    console.log('Deleting:', selectedStudentId, selectedCourseId)
    // Call your delete API here
    setDeleteModal(false)
  }

  // Pagination Logic
  const totalPages = Math.ceil(data.length / itemsPerPage)
  useEffect(() => {
    if (currentPage > totalPages && totalPages !== 0) {
      setCurrentPage(1)
    }
  }, [data, totalPages])

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem)

  return (
    <>
      <style>
        {`
          .blinking-link {
            color: blue;
            text-decoration: none;
            cursor: pointer;
            animation: blink 1s infinite;
            font-weight:bold;
          }

          @keyframes blink {
            0% { color: blue; }
            50% { color: red; }
            100% { color: blue; }
          }

          .dropdown-toggle-no-caret::after {
            display: none !important;
          }

          /* Ensure dropdown menu can overflow table boundaries */
          .table td {
            overflow: visible !important;
          }

          .table tbody tr {
            overflow: visible !important;
          }

          /* Fix dropdown menu positioning and z-index - ensure it appears above table container */
          .dropdown-menu {
            z-index: 1050 !important;
            position: fixed !important;
          }

          /* Ensure table container allows dropdown overflow but prevents scrolling */
          .table-container {
            overflow-x: auto;
            overflow-y: visible !important;
            position: relative;
          }

          /* Ensure dropdown wrapper has proper z-index */
          .dropdown-wrapper {
            position: relative;
            z-index: 9999 !important;
          }

          /* Ensure Card allows dropdown to overflow */
          .table-card {
            overflow: visible !important;
          }

          /* Table wrapper inside card - allows dropdown to escape */
          .table-wrapper {
            overflow-x: auto;
            overflow-y: visible !important;
            max-height: none !important;
            position: relative;
          }

          /* Ensure dropdown menu renders outside container */
          .dropdown-menu.show {
            z-index: 1050 !important;
            position: fixed !important;
          }

          /* Prevent table from clipping dropdown */
          .table {
            overflow: visible !important;
          }

          /* Ensure dropdown toggle button container allows overflow */
          .table td {
            position: relative;
            overflow: visible !important;
          }

          /* Bootstrap dropdown popper container - ensure it's not clipped */
          .dropdown-menu[data-popper-placement] {
            z-index: 1050 !important;
            position: fixed !important;
          }
        `}
      </style>
      <div 
        style={{ 
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px',
        }}
      >
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px',
          }}
        >
        <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
          <div 
            className="d-flex justify-content-between align-items-center"
            style={{
              background: '#F3F4F6',
              paddingLeft: '28px',
              paddingRight: '28px',
              paddingTop: '12px',
              paddingBottom: '12px',
              overflow: 'visible',
              borderBottom: '1px solid #D1D3D4',
              width: '100%',
            }}
          >
            {/* Left: Title and Add Button */}
            <div className="d-flex align-items-center gap-3">
              {/* School Logo */}
              <div style={{ 
                width: '40px', 
                height: '40px', 
                borderRadius: '50%', 
                overflow: 'hidden', 
                background: '#223843',
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                flexShrink: 0,
              }}>
                {!logoError ? (
                  <img 
                    src={logo} 
                    alt="School Logo" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                )}
              </div>
              
              <h3 
                className="m-0 fw-bold text-start" 
                style={{ 
                  letterSpacing: '-0.02em',
                  overflow: 'visible',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontSize: isMobile ? '14px' : 'clamp(18px, 2.5vw, 22px)',
                  color: '#223843',
                  lineHeight: '1.2',
                  fontFamily: 'Inter, system-ui, sans-serif',
                }}
              >
                Enrolled Courses for{' '}
                {isMobile && (
                  <br/>
                )}
                <span style={{ color: '#223843', fontWeight: '600' }}>
                  {(studentName || studentDetails?.name)
                    ?.charAt(0)
                    .toUpperCase() +
                    (studentName || studentDetails?.name)?.slice(1)}
                </span>
                {/* {(studentAdmissionNumber || studentDetails?.admission_number) &&
                  (studentName || studentDetails?.name) &&
                  ' - '}
                <span style={{ color: '#223843', fontWeight: '600' }}>
                  {studentAdmissionNumber || studentDetails?.admission_number}
                </span> */}
              </h3>
            </div>
            
            {/* Right: Profile Icon with Dropdown */}
            {!isMobile && (
              <ProfileDropdown logout={logout} />
            )}
          </div>
        </div>
        </div>
        <div
          className="container-fluid p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px',
            overflowX: 'hidden',
            maxWidth: '100%',
          }}
        >
          {/* Items Per Page Selector & Navigation Buttons */}
          <div className="d-flex justify-content-between align-items-start mb-4" style={{ flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '12px' : '0', alignItems: isMobile ? 'flex-start' : 'center' }}>
            <div className="d-flex align-items-center gap-3">
              <div 
                className="d-flex align-items-center"
                style={{
                  backgroundColor: '#ffffff',
                  padding: isMobile ? '6px 12px' : '8px 16px',
                  borderRadius: '8px',
                  gap: isMobile ? '6px' : '8px',
                  border: '1px solid #D1D3D4',
                }}
              >
                <span style={{ color: '#6b7280', fontSize: isMobile ? '11px' : '13px', whiteSpace: 'nowrap', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Show:
                </span>
                <Form.Select
                  className="w-auto"
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(parseInt(e.target.value))
                    setCurrentPage(1)
                  }}
                  style={{
                    borderRadius: '6px',
                    border: '1px solid #D1D3D4',
                    backgroundColor: '#ffffff',
                    color: '#111827',
                    fontSize: isMobile ? '11px' : '13px',
                    fontWeight: '500',
                    padding: isMobile ? '2px 24px 2px 8px' : '4px 32px 4px 12px',
                    minWidth: isMobile ? '100px' : '140px',
                    transition: 'all 0.2s ease',
                    cursor: 'pointer',
                    height: isMobile ? '28px' : '36px',
                    fontFamily: 'Inter, system-ui, sans-serif',
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#223843'
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#D1D3D4'
                  }}
                >
                  <option value="10">10 per page</option>
                  <option value="20">20 per page</option>
                  <option value="30">30 per page</option>
                </Form.Select>
              </div>
            </div>
            <div
              className="d-flex gap-3 flex-wrap"
              style={{
                gap: isMobile ? '8px' : '12px',
                flexDirection: isMobile ? 'row' : 'row',
                flexWrap: isMobile ? 'nowrap' : 'wrap',
                alignItems: isMobile ? 'flex-start' : 'center',
              }}
            >
              {(user?.user_type === 'admin' || user?.user_type === 'teacher') && (
                <div
                  className="d-flex align-items-center gap-2"
                  style={{ transition: 'all 0.2s ease', cursor: 'pointer', gap: isMobile ? '6px' : '8px' }}
                  onMouseEnter={(e) => {
                    const button = e.currentTarget.querySelector('button')
                    const text = e.currentTarget.querySelector('span')
                    if (button) {
                      button.style.backgroundColor = '#223843'
                      button.style.borderColor = '#223843'
                      button.style.transform = 'scale(1.05)'
                    }
                    if (text) {
                      text.style.transform = 'scale(1.05)'
                    }
                    e.currentTarget.style.transform = 'scale(1.02)'
                  }}
                  onMouseLeave={(e) => {
                    const button = e.currentTarget.querySelector('button')
                    const text = e.currentTarget.querySelector('span')
                    if (button) {
                      button.style.backgroundColor = '#223843'
                      button.style.borderColor = '#223843'
                      button.style.transform = 'scale(1)'
                    }
                    if (text) {
                      text.style.transform = 'scale(1)'
                    }
                    e.currentTarget.style.transform = 'scale(1)'
                  }}
                >
                  <button
                    onClick={() => {
                      if (user?.user_type === 'admin') {
                        navigate('/students')
                      } else if (user?.user_type === 'teacher') {
                        navigate('/TeacherStudent')
                      }
                    }}
                    style={{
                      width: isMobile ? '36px' : '48px',
                      height: isMobile ? '36px' : '48px',
                      borderRadius: '50%',
                      border: '1px solid #223843',
                      backgroundColor: '#223843',
                      color: '#ffffff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      flexShrink: 0,
                    }}
                    title="Go to Active Students"
                  >
                    <FaArrowLeft size={isMobile ? 16 : 20} />
                  </button>
                  <span style={{ 
                    fontSize: isMobile ? '12px' : '14px', 
                    color: '#111827', 
                    fontFamily: 'Inter, system-ui, sans-serif', 
                    fontWeight: '500',
                    transition: 'transform 0.2s ease',
                    display: 'inline-block',
                    lineHeight: isMobile ? '1.1' : undefined,
                    maxWidth: isMobile ? '200px' : undefined,
                  }}>
                    Go to Active Students
                  </span>
                </div>
              )}
              
              {user?.user_type !== 'teacher' && isAdmin && (
                <div
                  className="d-flex align-items-center gap-2"
                  style={{ transition: 'all 0.2s ease', cursor: 'pointer', gap: isMobile ? '6px' : '8px' }}
                  onMouseEnter={(e) => {
                    const button = e.currentTarget.querySelector('button')
                    const text = e.currentTarget.querySelector('span')
                    if (button) {
                      button.style.backgroundColor = '#059669'
                      button.style.borderColor = '#059669'
                      button.style.transform = 'scale(1.05)'
                    }
                    if (text) {
                      text.style.transform = 'scale(1.05)'
                    }
                    e.currentTarget.style.transform = 'scale(1.02)'
                  }}
                  onMouseLeave={(e) => {
                    const button = e.currentTarget.querySelector('button')
                    const text = e.currentTarget.querySelector('span')
                    if (button) {
                      button.style.backgroundColor = '#10B981'
                      button.style.borderColor = '#10B981'
                      button.style.transform = 'scale(1)'
                    }
                    if (text) {
                      text.style.transform = 'scale(1)'
                    }
                    e.currentTarget.style.transform = 'scale(1)'
                  }}
                >
                  <button
                    onClick={handleBack}
                    style={{
                      width: isMobile ? '36px' : '48px',
                      height: isMobile ? '36px' : '48px',
                      borderRadius: '50%',
                      border: '1px solid #10B981',
                      backgroundColor: '#10B981',
                      color: '#ffffff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      flexShrink: 0,
                    }}
                    title={`Go to ${(studentName || studentDetails?.name)?.charAt(0).toUpperCase() + (studentName || studentDetails?.name)?.slice(1)} profile`}
                  >
                    <FaArrowLeft size={isMobile ? 16 : 20} style={{ transform: 'rotate(180deg)' }} />
                  </button>
                  <span style={{ 
                    fontSize: isMobile ? '12px' : '14px', 
                    color: '#111827', 
                    fontFamily: 'Inter, system-ui, sans-serif', 
                    fontWeight: '500',
                    transition: 'transform 0.2s ease',
                    display: 'inline-block',
                    lineHeight: isMobile ? '1.1' : undefined,
                    maxWidth: isMobile ? '200px' : undefined,
                  }}>
                    Go to{' '}
                    <span className="fw-bold">
                      {(studentName || studentDetails?.name)
                        ?.charAt(0)
                        .toUpperCase() +
                        (studentName || studentDetails?.name)?.slice(1)}{' '}
                    </span>
                    profile
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* Add New Enroll button (dedicated row, not in header) */}
          <div
            className="d-flex align-items-center mb-4"
            style={{ justifyContent: isMobile ? 'flex-end' : 'flex-end' }}
          >
              <button
                onClick={() => setShowModal(true)}
                style={{
                  borderRadius: '10px',
                  padding: '6px 10px',
                  height: '44px',
                  border: 'none',
                  backgroundColor: '#223843',
                  color: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1f323a'
                  e.currentTarget.style.transform = 'scale(1.03)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Enroll New Course"
              >
                <Book size={18} />
                <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Add New Enroll
                </span>
              </button>
          </div>

        {/* Table */}
        <Card className="table-card" style={{ border: '1px solid #D1D3D4', borderRadius: '12px', overflow: 'visible', backgroundColor: '#ffffff', position: 'relative' }}>
          <div className="table-wrapper" style={{ overflowX: 'auto', overflowY: 'visible', position: 'relative', borderRadius: '12px' }}>
          <Table className="table mb-0" style={{ borderRadius: '12px', overflow: 'visible', position: 'relative', marginBottom: '0' }}>
            <Thead>
              <Tr style={{ backgroundColor: '#F3F4F6' }}>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Course Name</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Class Name</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Roll Number</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Enrolled Date</Th>
                {isAdmin && (
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'center', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif',textAlign: 'left' }}>Action</Th>
                )}
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.length > 0 ? (
                currentItems.map((item, index) => (
                  <Tr 
                    key={index}
                    style={{ 
                      backgroundColor: index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)',
                      transition: 'background-color 0.2s ease',
                      borderBottom: '1px solid #E5E7EB',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(37, 99, 235, 0.06)'
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)'
                    }}
                  >
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.course ? item.course.name : 'N/A'}</Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.class ? item.class.class_name : 'N/A'}</Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.roll_number || 'N/A'}</Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                      {item.enroll_date
                        ? new Date(item.enroll_date).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric',
                          })
                        : 'N/A'}
                    </Td>
                    {isAdmin && (
                    <Td className="text-center" style={{ padding: '16px', border: 'none', position: 'relative' }}>
                      {/* Desktop View - Dropdown */}
                      <div className="d-none d-md-block">
                        <Dropdown
                          popperConfig={{
                            modifiers: [
                              {
                                name: 'preventOverflow',
                                options: {
                                  boundary: 'viewport',
                                  padding: 8,
                                },
                              },
                              {
                                name: 'flip',
                                options: {
                                  fallbackPlacements: ['top', 'bottom', 'left', 'right'],
                                  boundary: 'viewport',
                                  padding: 8,
                                },
                              },
                              {
                                name: 'offset',
                                options: {
                                  offset: [0, 8],
                                },
                              },
                            ],
                            strategy: 'fixed',
                          }}
                        >
                          <Dropdown.Toggle
                            variant="light"
                            id={`dropdown-${item.student_id}-${item.course_id}`}
                            style={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '50%',
                              backgroundColor: 'transparent',
                              border: '1px solid #D1D3D4',
                              padding: '0',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              transition: 'all 0.2s ease',
                            }}
                            className="dropdown-toggle-no-caret"
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#223843'
                              e.currentTarget.style.borderColor = '#223843'
                              e.currentTarget.style.color = '#ffffff'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = 'transparent'
                              e.currentTarget.style.borderColor = '#D1D3D4'
                              e.currentTarget.style.color = '#111827'
                            }}
                          >
                            <BsThreeDotsVertical style={{ color: 'inherit' }} />
                          </Dropdown.Toggle>

                          <Dropdown.Menu
                            style={{
                              borderRadius: '8px',
                              border: '1px solid #D1D3D4',
                              padding: '8px',
                              minWidth: '180px',
                            }}
                          >
                            <Dropdown.Item
                              onClick={() =>
                                handleEditEnroll(
                                  item.student_id,
                                  item.course_id,
                                  item.class_id,
                                  item.enroll_date,
                                  item.roll_number,
                                )
                              }
                              style={{
                                fontSize: '13px',
                                padding: '10px 12px',
                                color: '#111827',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                transition: 'all 0.2s ease',
                                borderRadius: '6px',
                                fontFamily: 'Inter, system-ui, sans-serif',
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#F59E0B'
                                e.currentTarget.style.color = '#ffffff'
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent'
                                e.currentTarget.style.color = '#111827'
                              }}
                            >
                              <BsPencilFill size={18} /> Edit Course
                            </Dropdown.Item>

                            {user?.user_type !== 'teacher' && (
                              <Dropdown.Item
                                onClick={() =>
                                  handleDeleteEnroll(
                                    item.student_id,
                                    item.course_id,
                                    item.course?.name,
                                  )
                                }
                                style={{
                                  fontSize: '13px',
                                  padding: '10px 12px',
                                  color: '#111827',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  transition: 'all 0.2s ease',
                                  borderRadius: '6px',
                                  fontFamily: 'Inter, system-ui, sans-serif',
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#EF4444'
                                  e.currentTarget.style.color = '#ffffff'
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent'
                                  e.currentTarget.style.color = '#111827'
                                }}
                              >
                                <BsTrashFill size={18} /> Delete Course
                              </Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>

                      {/* Mobile View - Circular Buttons in Single Line */}
                      <div className="d-md-none d-flex justify-content-start gap-2" >
                        <button
                          onClick={() =>
                            handleEditEnroll(
                              item.student_id,
                              item.course_id,
                              item.class_id,
                              item.enroll_date,
                              item.roll_number,
                            )
                          }
                          style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            backgroundColor: '#F59E0B',
                            border: 'none',
                            color: '#ffffff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.2s ease',
                            cursor: 'pointer',
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#D97706'
                            e.currentTarget.style.transform = 'scale(1.1)'
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#F59E0B'
                            e.currentTarget.style.transform = 'scale(1)'
                          }}
                          title="Edit Course"
                        >
                          <BsPencilFill size={16} />
                        </button>
                        {user?.user_type !== 'teacher' && (
                          <button
                            onClick={() =>
                              handleDeleteEnroll(
                                item.student_id,
                                item.course_id,
                                item.course?.name,
                              )
                            }
                            style={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '50%',
                              backgroundColor: '#EF4444',
                              border: 'none',
                              color: '#ffffff',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              transition: 'all 0.2s ease',
                              cursor: 'pointer',
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#DC2626'
                              e.currentTarget.style.transform = 'scale(1.1)'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '#EF4444'
                              e.currentTarget.style.transform = 'scale(1)'
                            }}
                            title="Delete Course"
                          >
                            <BsTrashFill size={16} />
                          </button>
                        )}
                      </div>
                    </Td>
                    )}
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan={isAdmin ? 5 : 4} className="text-center" style={{ padding: '40px', fontSize: '14px', color: '#6b7280', fontFamily: 'Inter, system-ui, sans-serif' }}>
                    No records found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
          </div>
        </Card>

        <TablePagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
          indexOfFirstItem={indexOfFirstItem}
          indexOfLastItem={indexOfLastItem}
          totalItems={data.length}
          itemLabel="enrolled courses"
          maxVisiblePages={isMobile ? 5 : 7}
          paginationScrollable
        />
        </div>
        <DeleteEnrolledCourse
          show={deleteModal}
          onHide={() => setDeleteModal(false)}
          onConfirm={handleConfirmDelete}
          studentId={selectedStudentId}
          courseId={selectedCourseId}
          courseName={selectedCoursename}
          studentName={
            ((studentName || studentDetails?.name)?.charAt(0).toUpperCase() ||
              '') + (studentName || studentDetails?.name)?.slice(1)
          }
        />
        <Modal
          size="lg"
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
        >
          <Modal.Header closeButton 
        closeVariant="white"
        className="text-white" style={{backgroundColor: '#223843'}}>
            <Modal.Title>Enroll New Course</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSave}>
              {/* Course Name */}
              <Form.Group className="mb-3">
                <Form.Label>Course *</Form.Label>
                <Form.Select
                  name="course_id"
                  value={selectedNewCourse}
                  onChange={handleCourseChange}
                  required
                >
                  <option value="">Select Course</option>
                  {courses.map((course) => (
                    <option key={course.id} value={course.id}>
                      {course.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              {/* Duration */}

              {classes.length === 0 && selectedNewCourse && (
                <p style={{ color: 'red', letterSpacing: '1px' }}>
                  The selected course has no class. Please{' '}
                  <span
                    className="blinking-link"
                    onClick={handleNavigateToCreateClass}
                  >
                    click here
                  </span>{' '}
                  to create new class.
                </p>
              )}

              <Form.Group className="mb-3">
                <Form.Label>Class *</Form.Label>
                <Form.Select
                  name="class_id"
                  value={newEnroll.class_id}
                  onChange={handleClassChange}
                  disabled={!courseTouched || classes.length === 0}
                >
                  <option value="">Select Class</option>
                  {classes.map((clas) => (
                    <option key={clas.id} value={clas.id}>
                      {clas.class_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {studentCount !== null && studentCount !== 'No data available' && (
                <div
                  style={{
                    color: countColor,
                    marginBottom: '5px',
                    fontWeight: 'bold',
                    letterSpacing: '1px',
                  }}
                >
                  {studentCount.current === null
                    ? `There are still ${studentCount.maximum_limit} seats available in this class.`
                    : studentCount.current === studentCount.maximum_limit
                    ? 'There are no more seats available in this class.'
                    : `There are ${
                        studentCount.maximum_limit - studentCount.current
                      } seats left in this class.`}
                </div>
              )}

              <Form.Group className="mb-3">
                <Form.Label>Roll Number</Form.Label>
                <Form.Control
                  type="text"
                  name="roll_number"
                  value={newEnroll.roll_number}
                  onChange={handleInputChange}
                  placeholder="Enter Roll Number"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Enrolled Date</Form.Label>
                <Form.Control
                  type="date"
                  name="enroll_date"
                  value={newEnroll.enroll_date}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>

              <Modal.Footer>
                <Button variant="danger" onClick={() => setShowModal(false)}>
                  Cancel
                </Button>
                <Button variant="success" type="submit">
                  Save Enrolled Course
                </Button>
              </Modal.Footer>
            </Form>
          </Modal.Body>
        </Modal>
        <Modal
          show={showEditModal}
          onHide={() => setShowEditModal(false)}
          centered
          size="lg"
        >
          <Modal.Header closeButton 
        closeVariant="white"
        className="bg-warning text-dark">
            <Modal.Title>Edit Enrolled Course</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="formCourseName">
                <Form.Label>Course</Form.Label>
                <Form.Control
                  type="text"
                  value={
                    courses.find((c) => c.id === editFormData.course_id)
                      ?.name || ''
                  }
                  disabled={!courseTouched || classes.length === 0}
                />
              </Form.Group>

              <Form.Group controlId="formClassSelect">
                <Form.Label>Select New Class</Form.Label>
                <Form.Select
                  value={editFormData.class_id}
                  onChange={handleClassChange}
                >
                  <option value="">Select Class</option>
                  {classes
                    .filter((cls) => cls.course_id === editFormData.course_id)
                    .map((cls) => (
                      <option key={cls.id} value={cls.id}>
                        {cls.class_name}
                      </option>
                    ))}
                </Form.Select>
              </Form.Group>

              {studentCount !== null && studentCount !== 'No data available' && (
                <div
                  style={{
                    color: countColor,
                    marginBottom: '5px',
                    fontWeight: 'bold',
                    letterSpacing: '1px',
                  }}
                >
                  {studentCount.current === null
                    ? `There are still ${studentCount.maximum_limit} seats available in this class.`
                    : studentCount.current === studentCount.maximum_limit
                    ? 'There are no more seats available in this class.'
                    : `There are ${
                        studentCount.maximum_limit - studentCount.current
                      } seats left in this class.`}
                </div>
              )}

              <Form.Group className="mb-3">
                <Form.Label>Roll Number</Form.Label>
                <Form.Control
                  type="text"
                  name="roll_number"
                  value={editFormData.roll_number || ''}
                  onChange={(e) =>
                    setEditFormData({
                      ...editFormData,
                      roll_number: e.target.value,
                    })
                  }
                  placeholder="Enter Roll Number"
                />
              </Form.Group>

              {user?.user_type !== 'teacher' && (
                <Form.Group className="mb-3">
                  <Form.Label>Enrolled Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="enroll_date"
                    value={editFormData.enroll_date || ''}
                    onChange={(e) =>
                      setEditFormData({
                        ...editFormData,
                        enroll_date: e.target.value,
                      })
                    }
                  />
                </Form.Group>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>
              Cancel
            </Button>
            <Button variant="warning" onClick={handleUpdateClass}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}
export default EnrolledCourses

